<input
  type="search"
  #searchBox
  (keyup)="search(searchBox.value)"
  class="form-control mb-3"
  [placeholder]="'attendance.contactList.searchPlaceholder' | translate"
/>

@if (pager.total > 0) {
<div class="card-body table-responsive custom-rounded-table">
  <table class="table table-striped table-centered mb-0">
    <thead>
      <tr>
        <th class="text-primary-emphasis">{{ 'attendance.contactList.name' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.contactList.phone' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.contactList.email' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.contactList.company' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.contactList.position' | translate }}</th>
        <th class="sr-only custom-button-select">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      @for (item of pager.list; track $index) {
      <tr role="row">
        <td class="table-user">
          <img
            class="me-2 rounded-circle"
            [src]="getContactImage(item)"
            [alt]="item.name"
            (error)="onImageError($event)"
          />
          <strong class="text-truncate">{{ item.name }}</strong>
          @if (item.blockedChannels && item.blockedChannels.length > 0) {
          <span class="text-muted whitespace-nowrap">{{ 'attendance.contactList.blocked' | translate }}</span>
          }
        </td>
        <td>
          {{ getMaskedPhone(item.phone) }}
        </td>
        <td>
          {{ item.email ?? "-" }}
        </td>
        <td>
          {{ item.contactCompany ?? "-" }}
        </td>
        <td>
          {{ item.contactPosition ?? "-" }}
        </td>
        <td align="right">
          <button class="btn btn-dark btn-sm" (click)="select(item)">
            <i class="ri-check-line"></i>
            {{ 'attendance.contactList.select' | translate }}
          </button>
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if (pager.total > pager.perPage) {
  <paginator
    [pager]="pager"
    (onPager)="loadPage($event)"
  />
}
</div>
}
